import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { Fade } from 'react-reveal';
import { Actions } from '../../flux';
import { images, texts, videos, quem_somos } from '../../settings';
import { PersonProfile, VideoBg, DelayLink, HoveredImage } from '../../components';

import './QuemSomos.scss';

class QuemSomos extends Component {
  constructor(props) {
    super(props);

    this.state = {
      width: window.innerWidth,

      maxSlidesQuemSomos: 3,
      cActiveQuemSomos: 0,
      loaderBarWidthQuemSomos: 0,
      loaderBarIndexQuemSomos: 0,
      //
      tempoSlider: 15000,
    };

    this.images = images;
    this.videos = videos;
    this.texts = texts;
    this.quem_somos_texts = quem_somos;

    this.contentText = React.createRef();
    this.runTransition = this.runTransition.bind(this);
  }

  scrollTop() {
    window.scrollTo({ top: this.contentText.current.offsetTop });
  }

  runTransition() {
    Actions.globalTransition();
  }

  changeTemasButton(num, tipoTema) {
    const newIndex = Object.assign({}, this.state);
    if (num == newIndex[`cActive${tipoTema}`]) {
      return false;
    }
    newIndex[`cActive${tipoTema}`] = num;
    this.setState(newIndex);
    this.reloadTimer(tipoTema);
  }

  changeTemasPrev(num, tipoTema) {
    const newIndex = Object.assign({}, this.state);
    newIndex[`cActive${tipoTema}`] = newIndex[`cActive${tipoTema}`] - 1 < 0 ? newIndex[`maxSlides${tipoTema}`] : num;
    this.setState(newIndex);
    this.reloadTimer(tipoTema);
  }

  changeTemasNext(num, tipoTema) {
    const newIndex = Object.assign({}, this.state);
    newIndex[`cActive${tipoTema}`] = newIndex[`cActive${tipoTema}`] + 1 > newIndex[`maxSlides${tipoTema}`] ? 0 : num;
    this.setState(newIndex);
    this.reloadTimer(tipoTema);
  }

  loadBar(tipoTema) {
    var percent = this.state.tempoSlider / 100;
    setInterval(() => {
      let index = this.state[`loaderBarIndex${tipoTema}`];
      index++;
      if (index <= 100) {
        const newIndex = Object.assign({}, this.state);
        newIndex[`loaderBarIndex${tipoTema}`] = index;
        newIndex[`loaderBarWidth${tipoTema}`] = index + '%';
        this.setState(newIndex);
      } else {
        this.changeTemasNext(this.state[`cActive${tipoTema}`] + 1, tipoTema);
      }
    }, percent);
  }

  reloadTimer(tipoTema) {
    this.setState({ loaderBarIndexQuemSomos: 0, loaderBarWidthQuemSomos: 0 });
  }

  componentDidMount() {
    Actions.headerIntern();
    this.scrollTop();

    // this.loadBar('QuemSomos');
  }

  render() {
    const { cActiveQuemSomos, loaderBarWidthQuemSomos, maxSlidesQuemSomos } = this.state;

    return (
      <div className="views" ref={this.contentText}>
        <Helmet>
          <title>Quem Somos - {this.texts.title}</title>
        </Helmet>

        <div className="parallax-image">
          <img src={this.images.quem_somos.first_bg} />
        </div>

        <div className="quem-somos" ref="quem-somos">
          <section className="quem-somos-area page--green">
            <div className="container">
              <div className="row">
                <div className="col-12">
                  <Fade bottom>
                    <div className="card card--page-body card--green">
                      <div className="card__content">
                        <div className="card__content__header">
                          <h1 className="title">Quem somos</h1>
                        </div>
                        <div className="card__content__body">
                          <p className="gri_text">
                            Oi! Somos uma organização sem fins lucrativos chamada ANBIMA, a Associação Brasileira das
                            Entidades dos Mercados Financeiro e de Capitais. Significa que reunimos bancos, gestoras,
                            corretoras, distribuidoras e administradoras – instituições de diferentes portes e segmentos
                            que retratam a pluralidade do mercado.
                            <span className="gri_label">
                              GRI <b>102-1, 102-5, 102-6</b>
                            </span>
                          </p>
                          <p className="gri_text">
                            Em 2019, completamos dez anos de vida, mas essa trajetória começou da união de outras duas
                            entidades que, juntas, somam quase um século de história. Por isso, estamos divididos em
                            duas cidades: a sede no Rio de Janeiro, RJ, e um escritório com as áreas de Negócios, em São
                            Paulo, SP.
                            <span className="gri_label">
                              GRI <b>102-3, 102-4</b>
                            </span>
                            <br />
                            <br />
                            Neste ano, comemoramos outro importante aniversário: os 40 anos do Selic, o Sistema Especial
                            de Liquidação e de Custódia, do Banco Central. A partir de um convênio que temos com o BC,
                            cuidamos do dia a dia do sistema, que é responsável pela custódia, pelo registro e pela
                            liquidação dos títulos públicos do Tesouro Nacional.
                            <br />
                            <br />
                            Nossa atuação em defesa dos interesses dos associados se dá por meio de quatro compromissos:
                            representar, autorregular, informar e educar. Saiba mais sobre cada um abaixo.
                            <span className="gri_label">
                              GRI <b>102-2</b>
                            </span>
                          </p>
                        </div>
                      </div>
                      <div className="card__image">
                        <img src={images.quem_somos.img_quem_somos} />
                      </div>
                    </div>
                  </Fade>
                </div>
              </div>
            </div>
          </section>

          <div className="compromissos-area-container">
            <section className="compromissos-area">
              <div className="container">
                <div className="row">
                  <div className="col-5"></div>
                  <div className="col-7">
                    <Fade bottom>
                      <h2 className="green">Compromissos</h2>
                    </Fade>
                  </div>
                </div>
              </div>
            </section>

            <section className="compromissos-area compromissos-area--topics">
              <div className="container">
                <div className="row">
                  <div className="col-5">
                    <div className="pessoa_destaque">
                      <img className="pessoa_destaque--cabeca" src={this.images.quem_somos.pessoa3_cabeca} />
                      <img className="pessoa_destaque--braco" src={this.images.quem_somos.pessoa3_braco} />
                      <img src={this.images.quem_somos.pessoa3_corpo} />
                    </div>
                  </div>
                  <div className="col-7">
                    <div className="compromissos_c">
                      <div className="compromissos_c__header">
                        <ul>
                          {this.quem_somos_texts.compromissos.map((item, index) => (
                            <li
                              key={index}
                              className={cActiveQuemSomos == index ? ['active'] : ['']}
                              onClick={() => this.changeTemasButton(index, 'QuemSomos')}
                            >
                              {item.title}
                            </li>
                          ))}
                        </ul>
                      </div>

                      {/* <div className="compromissos_c__loader">
                        <div className="loader">
                          <div className="loader_bar" style={{ width: loaderBarWidthQuemSomos }}></div>
                        </div>
                      </div> */}

                      <div className="compromissos_c__content">
                        <p>{this.quem_somos_texts.compromissos[cActiveQuemSomos].text}</p>
                      </div>

                      <div className="compromissos_c__nav">
                        <div
                          className="c__nav__button c__nav__button--prev"
                          onClick={() => this.changeTemasPrev(cActiveQuemSomos - 1, 'QuemSomos')}
                        ></div>
                        <div className="c__nav__status">
                          <b>{cActiveQuemSomos + 1}</b>/{maxSlidesQuemSomos + 1}
                        </div>
                        <div
                          className="c__nav__button c__nav__button--next"
                          onClick={() => this.changeTemasNext(cActiveQuemSomos + 1, 'QuemSomos')}
                        ></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>

          <section className="missao-area">
            <div className="container">
              <div className="row">
                <div className="col-12">
                  <Fade bottom>
                    <h2 className="big bordered_text bordered_text--dark-gray gri_text gri_text--fixed">
                      Visão, missão <br className="br_mobile" />e valores
                      <span className="gri_label">
                        GRI <b>102-16</b>
                      </span>
                    </h2>
                  </Fade>
                </div>

                <div className="col-4">
                  <Fade bottom>
                    <div className="card card--green">
                      <div className="card__content card__content--full">
                        <div className="card__content__header card__content__header--no-border">
                          <img src={images.quem_somos.icon_visao} className="card__icon" />
                          <h3 className="title title--small">Visão</h3>
                        </div>
                        <div className="card__content__body">
                          <p>Mercado forte se faz com instituições fortes.</p>
                        </div>
                      </div>
                    </div>
                  </Fade>
                </div>

                <div className="col-4">
                  <Fade bottom>
                    <div className="card card--blue">
                      <div className="card__content card__content--full">
                        <div className="card__content__header card__content__header--no-border">
                          <img src={images.quem_somos.icon_missao} className="card__icon" />
                          <h3 className="title title--small">Missão</h3>
                        </div>
                        <div className="card__content__body">
                          <p>
                            Fortalecer a representação do setor e apoiar a evolução de um mercado de capitais capaz de
                            financiar o desenvolvimento econômico e social local e influenciar o mercado global.
                          </p>
                        </div>
                      </div>
                    </div>
                  </Fade>
                </div>

                <div className="col-4">
                  <Fade bottom>
                    <div className="card card--yellow">
                      <div className="card__content card__content--full">
                        <div className="card__content__header card__content__header--no-border">
                          <img src={images.quem_somos.icon_valores} className="card__icon" />
                          <h3 className="title title--small">Valores</h3>
                        </div>
                        <div className="card__content__body">
                          <p>Cooperação, excelência, inovação, integridade, pluralidade e responsabilidade.</p>
                        </div>
                      </div>
                    </div>
                  </Fade>
                </div>
              </div>
            </div>
          </section>

          <section className="perfil-associados-area perfil-associados-area--footer page--green">
            <div className="container">
              <div className="row">
                <div className="col-12">
                  <Fade bottom>
                    <div className="box-pill box-pill--blue box-pill--center">
                      <div className="box-pill__content box-pill__content--full">
                        <div className="row">
                          <div className="col col-3">
                            <img src={images.quem_somos.pessoa1} className="pessoa_destaque pessoa_destaque--1" />
                          </div>
                          <div className="col col-9 col--text">
                            <h4>Saiba mais sobre o perfil dos nossos associados</h4>
                            <DelayLink
                              to="/associados"
                              className="button button--aylen button--white-to-blue button--border-medium button--size-m button--round-l button--text-thick"
                            >
                              Explorar
                            </DelayLink>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Fade>
                </div>
              </div>
            </div>
          </section>

          <section className="empresas-participamos-area page--yellow">
            <div className="container">
              <div className="row">
                <div className="col-12">
                  <Fade bottom>
                    <div className="card card--page-body card--yellow">
                      <div className="card__content card__content--full">
                        <div className="card__content__header card__content__header--no-border">
                          <h2 className="title">Empresas de que participamos</h2>
                          <p className="gri_text">
                            Nossa atuação se fortalece com a participação em empresas que têm objetivos ligados aos da
                            Associação:{' '}
                            <span className="gri_label">
                              GRI <b>102-2, 102-13</b>
                            </span>
                          </p>
                        </div>
                        <div className="card__content__body">
                          <div className="row">
                            <div className="col-6">
                              <img src={images.quem_somos.galgo} />
                              <p>
                                Criada em 2016, a empresa, da qual somos acionistas com outras 12 entidades, é
                                responsável pelo Sistema Galgo. A plataforma faz a padronização das transferências de
                                informações entre 88 instituições da indústria de fundos, somando 566 usuários e 15.227
                                fundos de investimentos cadastrados até o fim de 2019.
                              </p>
                            </div>
                            <div className="col-6">
                              <img src={images.quem_somos.rtm} />
                              <p>
                                Maior provedora de serviços para integração do mercado financeiro, a empresa oferece
                                infraestrutura de telecomunicações e soluções de tecnologia em ambiente de nuvem
                                privada. São mais de 20 provedores de informações e serviços que conectam 531
                                instituições em 20 estados. Somos acionistas de 80% da RTM, enquanto a B3 é dona dos
                                outros 20%.
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Fade>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    );
  }
}

export { QuemSomos };
